import { apiService } from '../api.service';

import type { IBanner, IDynamicBanner } from '@/interfaces/banner';

export const BannerResource = {
  fetch: () => apiService.get<IBanner>('v1/banners/last'),
  popup: () => apiService.get<IDynamicBanner[]>('v1/banners/popup'),
};
